import { Offers } from '@dgx-pr-spa/shared/util';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { VIEW_OFFERS_FEATURE } from '../reducers';
import { OffersState } from '../reducers/offers.reducer';
import * as fromOffer from '@view-offers/store/reducers';

export const getViewOfferState =
  createFeatureSelector<fromOffer.ViewOffersState>(VIEW_OFFERS_FEATURE);

export const getOffersState = createSelector(
  getViewOfferState,
  (state) => state?.offers || ({} as OffersState)
);

export const getOffers = createSelector(
  getOffersState,
  (offers: OffersState) => offers.data || ({} as Offers)
);

export const getOffersLoading = createSelector(
  getOffersState,
  (offers: OffersState) => offers.loading
);

export const getOffersLoaded = createSelector(
  getOffersState,
  (offers: OffersState) => offers.loaded
);

export const getDeliveryAddress = createSelector(
  getOffers,
  (offers: Offers) => offers.delivery_address
);

export const getOffer = createSelector(
  getOffersState,
  (offers: OffersState) => offers.data?.offer
);

export const getCurrentItem = createSelector(
  getOffers,
  (offers: Offers) => offers.current_item
);

export const getContact = createSelector(
  getOffersState,
  (offers: OffersState) => offers.data.contact_details
);
